import { Alert as ReactAlert } from '@a-ui/react';
import React from 'react';
import { useMessage } from '../../state/Message';
import { setMessageAsSeen, unsetMessage } from '../../state/Message/actions';
import Typography from '../Typography';

interface GlobalStateMessageProps {
  location: string;
}

const GlobalStateMessage: React.FC<GlobalStateMessageProps> = ({ location: locationToDisplay }) => {
  const {
    state: { message, type, seen, location },
    dispatch,
  } = useMessage();

  const handleClose = () => {
    dispatch(unsetMessage());
  };

  React.useLayoutEffect(() => {
    if (seen) {
      dispatch(unsetMessage());
    }

    dispatch(setMessageAsSeen());
  }, []);

  if (!message || location !== locationToDisplay) {
    return <></>;
  }

  return (
    <div className="u-margin-top u-margin-bottom">
      <ReactAlert inline theme={type} onClose={handleClose}>
        <Typography>{message}</Typography>
      </ReactAlert>
    </div>
  );
};

export default GlobalStateMessage;
